import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import endpoints from '../../API/endpoints'
import callAPI from '../../API/callSecureAPI'

export type Activity = {
    _id: string
    title: string
    category: string
    function: string
    budget: string
    description: string
    startDate: string
    endDate: string
    plannedStartDate?: string
    plannedEndDate?: string
    status: string
    isOwner?: boolean
    order?: number
    linkedValueMessages?: unknown[]
    therapeuticArea?: string
    externalId?: string
    source?: string
    processingStatus?: string

    type?: string
    titleLong?: string
    studyType?: string
    studyNumber?: string
    documentNumber?: string
    dataSource?: string
    population?: string
    proactiveReactive?: string
    sponsorType?: string
    studyOwner?: string
    affiliateName?: string
    providerName?: string
    indication?: string
    countries?: string[]
    compoundName?: string[]
    genericName?: string[]
    funded?: boolean
    vendor?: boolean
    corporateOrRnDGoal?: boolean
    patientStudy?: boolean
    studyReportDate?: string | null
    terminationDate?: string | null
    resultsAvailableForExternalUseDate?: string | null
    lastSyncedAt?: string | null
    createdAt?: string
    updatedAt?: string
    linkedEvidence?: unknown[]
    linkedStrategicImperatives?: unknown[]
    linkedTppCells?: unknown[]
    deliverables?: unknown[]
    activityDependencies?: unknown[]
    primaryEvidence?: unknown[]
    ownerRoadmapName?: string | null
}
export type ActivityIntendedUses = string[]

export type ActivityCategories = string[]

const ONE_MINUTE = 1000 * 60
const FIVE_MINUTES = ONE_MINUTE * 5

export const useGetActivitiesQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const getActivities = async () => {
        const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

        const { url, method } = endpoints.getActivitiesForTable

        const response = await callAPI(url + strategyId, method, token)

        if (!response?.success) {
            throw new Error(response?.error ?? 'Failed to load activities')
        }

        return response.data
    }

    return useQuery<Activity[]>(['activities', strategyId], getActivities, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        retry: 3,
    })
}
